/* tslint:disable */
/* eslint-disable */
/**
 * MTX Brokerage API
 * Brokerage agent-facing API for dispositions, listings, and transactions
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface MlsNames
 */
export interface MlsNames {
}

/**
 * Check if a given object implements the MlsNames interface.
 */
export function instanceOfMlsNames(value: object): boolean {
    let isInstance = true;

    return isInstance;
}

export function MlsNamesFromJSON(json: any): MlsNames {
    return MlsNamesFromJSONTyped(json, false);
}

export function MlsNamesFromJSONTyped(json: any, ignoreDiscriminator: boolean): MlsNames {
    return json;
}

export function MlsNamesToJSON(value?: MlsNames | null): any {
    return value;
}

